const quizData = {
    questionArr: [
        {
            question:'What\' the catchy commercial song Pepsi created in 1939',
            answerOptions: [
                'Coke Time',
                'Nickle Nickle',
                'Dime Jingle',
                'Pepsi Time'
            ],
            trueAns: 'Nickle Nickle',
            trueFeedback: 'You Got it!',
            falseFeedback: 'The song name is actually "Nickle Nickle", it\'s really catchy, google it!'
        },
        {
            question:'Which of the following brands belongs to Coca Cola',
            answerOptions: [
                'Doritos',
                'Mountain Dew',
                'Minute Maid',
                'Quaker'
            ],
            trueAns: 'Minute Maid',
            trueFeedback: 'You Got it!',
            falseFeedback: 'Coca Cola acquired the Minute Maid Corporation in 1960.'
        },
        {
            question:'How many times did Pepsi face bankrupcy throughout the history',
            answerOptions: [
                '0',
                '1',
                '2',
                '3'
            ],
            trueAns: '2',
            trueFeedback: 'You Got it!',
            falseFeedback: 'First in 1923 due to a false investment on sugar post WWI, then again in 1931.'
        },
        {
            question:'About the Pepsi Paradox, what feature did the customers prefer in Pepsi over Coca Cola?',
            answerOptions: [
                'Brand',
                'Vision',
                'Taste',
                'Advertisements'
            ],
            trueAns: 'Taste',
            trueFeedback: 'You Got it!',
            falseFeedback: 'The paradox was a result of a blind taste test, where more customers picked Pepsi over Coca Cola'
        },
        {
            question:'Which company had its own mascot in the Japnese market?',
            answerOptions: [
                'Pepsi',
                'Coca Cola',
                'Sprite',
                'Root Beer'
            ],
            trueAns: 'Pepsi',
            trueFeedback: 'You Got it!',
            falseFeedback: 'It was Pepsi, check it out, it even has its own video game.'
        },
        {
            question:'In 2020, which company had more market share in the soda industry?',
            answerOptions: [
                'Pepsi',
                'Coca Cola',
                'Dr. Peper',
                'None'
            ],
            trueAns: 'Coca Cola',
            trueFeedback: 'You Got it!',
            falseFeedback: 'Coca Cola was the winner!'
        },
        {
            question:'Now comes the big debate...Coca Cola? or Pespi?',
            answerOptions: [
                'Pepsi',
                'Coca Cola',
                'Whatever...',
                'Nah, I don\'t dig sugar...'
            ],
            trueAns: true,
            trueFeedback: 'You Got it! No matter which soda you pick, customer is ALWAYS RIGHT!',
            falseFeedback: ''
        }
    ]
}

export default quizData;